import React from 'react';
import StabSearchBox from '../StabSearchBox';
import PropTypes from 'prop-types';

const SearchBox = () => (
  <StabSearchBox />
);

SearchBox.propTypes = {
  showStabSearchbox: PropTypes.bool.isRequired
};

export default SearchBox;



// WEBPACK FOOTER //
// ./src/universal/components/SearchBox/SearchBox.js